import React, { useState } from 'react';
// Framer Motion supprimé - utilisation d'animations CSS
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Eye, EyeOff, LogIn, Heart, Shield, Users, Activity } from 'lucide-react';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(email, password);
      
      if (!result.success) {
        setError(result.message || 'Erreur de connexion');
      } else {
        // Petit délai pour s'assurer que l'état est mis à jour
        setTimeout(() => {
          navigate('/dashboard');
        }, 100);
      }
    } catch (err) {
      console.error('Erreur lors de la connexion:', err);
      setError('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Partie gauche avec dégradé bleu */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 relative overflow-hidden animate-slide-in-left">
        {/* Formes décoratives animées */}
        <div className="absolute top-10 right-10 w-32 h-32 bg-white/10 rounded-full animate-pulse" />
        <div
          animate={{
            rotate: [360, 0],
            scale: [1, 0.8, 1],
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            ease: "linear"
          }}
          className="absolute bottom-20 left-10 w-24 h-24 bg-white/5 rounded-full"
        />
        <div
          animate={{
            y: [0, -20, 0],
            x: [0, 10, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="absolute top-1/3 left-1/4 w-16 h-16 bg-white/10 rounded-lg"
        />

        {/* Contenu de bienvenue */}
        <div className="relative z-10 flex flex-col justify-center items-center text-center text-white p-12">
          <div
            
            
            
            className="mb-8"
          >
            <Heart className="h-16 w-16 mx-auto mb-6 text-white/90" />
            <h1 className="text-4xl font-bold mb-4">
              Bienvenue sur HealthBridge
            </h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              Votre plateforme de gestion médicale intelligente
            </p>
          </div>

          <div
            
            
            
            className="space-y-6"
          >
            <div className="flex items-center space-x-4">
              <Shield className="h-6 w-6 text-blue-200" />
              <span className="text-blue-100">Sécurité et confidentialité garanties</span>
            </div>
            <div className="flex items-center space-x-4">
              <Users className="h-6 w-6 text-blue-200" />
              <span className="text-blue-100">Gestion complète des patients et médecins</span>
            </div>
            <div className="flex items-center space-x-4">
              <Activity className="h-6 w-6 text-blue-200" />
              <span className="text-blue-100">Suivi en temps réel des données médicales</span>
            </div>
          </div>

          <div
            
            
            
            className="mt-12 p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20"
          >
            <p className="text-blue-100 text-sm">
              "La santé est notre priorité, la technologie notre alliée"
            </p>
          </div>
        </div>
      </div>

      {/* Partie droite avec formulaire */}
      <div
        
        
        
        className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white"
      >
        <div className="w-full max-w-md">
          <div
            
            
            
            className="text-center mb-8"
          >
            <div
              
              
              
              className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4"
            >
              <Heart className="h-8 w-8 text-blue-600" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">
              Connexion
            </h2>
            <p className="text-gray-600">
              Accédez à votre tableau de bord médical
            </p>
          </div>

          <form
            
            
            
            className="space-y-6"
            onSubmit={handleSubmit}
          >
            {error && (
              <div
                
                
                className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm"
              >
                {error}
              </div>
            )}

            <div
              
              
              
            >
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Adresse email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                placeholder="test@xxxxx.cd"
              />
            </div>

            <div
              
              
              
            >
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Mot de passe
              </label>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                  placeholder="xxxxxxx"
                />
                <button
                  type="button"
                  
                  
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeOff className="h-5 w-5 text-gray-400" />
                  ) : (
                    <Eye className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              
              
              
              
              
              className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              ) : (
                <>
                  <LogIn className="h-5 w-5 mr-2" />
                  Se connecter
                </>
              )}
            </button>

            <div className="text-center text-sm text-gray-600 pt-4 space-y-2">
              <p>
                Médecin ?{' '}
                <Link to="/register-doctor" className="text-blue-600 hover:text-blue-700 font-medium">
                  Créer un compte médecin
                </Link>
              </p>
              <p>
                Patient ?{' '}
                <Link to="/register-patient" className="text-blue-600 hover:text-blue-700 font-medium">
                  Créer un compte patient
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
